module.exports = __webpack_public_path__ + "img/logo.e4c6055d.png";